import { Stack } from '@mui/material';
import { SettingsSectionProps } from './settings-section.types';
import { SettingsSectionCard } from './SettingsSectionCard';
import { SettingsSectionHeader } from './SettingsSectionHeader';

/**
 * The header + card primitives give granular control, but most settings groups
 * want the same default arrangement. This wrapper hides that wiring behind a
 * flat prop API so a new group is a single declarative block. It lives at the
 * `SettingsSection/` root because it is the entry point most callers should
 * reach for; the primitives in the subfolders are the escape hatch for unique
 * layouts (mirrors the `Page/` family).
 */
export const SettingsSection = ({ title, description, action, children }: SettingsSectionProps) => (
  <Stack spacing={1.5}>
    <SettingsSectionHeader title={title} description={description} action={action} />
    <SettingsSectionCard>{children}</SettingsSectionCard>
  </Stack>
);

SettingsSection.displayName = 'SettingsSection';
